var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import PropTypes from 'prop-types';
import { space, fontSize } from 'styled-system';
import { ChipContent } from '../ChipContent';
import { ChipLabel } from '../ChipLabel';
import { ChipInput } from '../ChipInput';
var propTypes = __assign(__assign(__assign({}, space.propTypes), fontSize.propTypes), { id: PropTypes.string.isRequired, name: PropTypes.string.isRequired, disabled: PropTypes.bool, selected: PropTypes.bool, facet: PropTypes.string, label: PropTypes.string, bridgeLabel: PropTypes.string, BridgeIcon: PropTypes.node, Icon: PropTypes.node, action: PropTypes.shape({
        Icon: PropTypes.node,
        title: PropTypes.string,
    }), Image: PropTypes.object });
var ChoiceChip = function (_a) {
    var id = _a.id, name = _a.name, disabled = _a.disabled, selected = _a.selected, children = _a.children, onClick = _a.onClick, label = _a.label, props = __rest(_a, ["id", "name", "disabled", "selected", "children", "onClick", "label"]);
    return (React.createElement(ChipLabel, __assign({ htmlFor: id }, props),
        React.createElement(ChipInput, { "data-testid": id, name: name, type: 'radio', role: 'radio', id: id, disabled: disabled, checked: selected, onChange: onClick }),
        React.createElement(ChipContent, __assign({ label: label, disabled: disabled, selected: selected }, props), children)));
};
ChoiceChip.displayName = 'Chip';
ChoiceChip.propTypes = propTypes;
ChoiceChip.defaultProps = {
    color: 'primary',
};
export default ChoiceChip;
//# sourceMappingURL=ChoiceChip.js.map